import GAIASignInRequiredToBrowseWrapper from "@gaiaProfessionals/Components/HCP/GAIASignInRequiredToBrowseWrapper";
import displayMeetYourHerbsProduct from "@gaiaProfessionals/Handlers/Custom/GAIADisplayMeetYourHerbsProduct";
import { CustomMeetYourHerbsState } from "@gaiaProfessionals/Store/MeetYourHerbs/GAIAMeetYourHerbsReducer";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { WidgetGroup } from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    isLegacyPage = "isLegacyPage",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isLegacyPage]: boolean;
    };
}

const mapStateToProps = (state: CustomMeetYourHerbsState) => {
    const location = getLocation(state);
    const pathnameLowerCase = location.pathname.toLowerCase();
    const parsedQueryString = parseQueryString<{ id: string }>(location.search);

    return {
        isLoading: state.customMeetYourHerbsReducer?.isLoading,
        purityId: parsedQueryString.id,
        successful: state.customMeetYourHerbsReducer?.successful,
    };
};

const mapDispatchToProps = {
    displayMeetYourHerbsProduct,
};

export interface MYHProductDetailsViewStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnInnerContainer?: GridContainerProps;
    topGridItem?: GridItemProps;
    middleGridItem?: GridItemProps;
    middleGridItemHidden?: HiddenProps;
    bottomGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridItemHidden?: HiddenProps;
    fullWidthGridItem?: GridItemProps;
    fullWidthInnerGridItem?: GridItemProps;
}

export const viewStyles: MYHProductDetailsViewStyles = {
    leftColumnGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            overflow: hidden;
        `,
    },
    topGridItem: { width: 12 },

    bottomGridItem: { width: 12 },
    rightColumnGridItem: { width: [12, 12, 12, 7, 7] },

    container: {
        css: css`
            /* direction: rtl; */
        `,
    },
    fullWidthGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    fullWidthInnerGridItem: {
        width: 12,
    },
};

const styles = viewStyles;

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const GAIAMYHProductDetailsView: React.FC<Props> = ({
    id,
    isLoading,
    displayMeetYourHerbsProduct,
    purityId,
    successful,
    fields
}) => {
    React.useEffect(() => {
        if (!isLoading && !fields.isLegacyPage) {
            displayMeetYourHerbsProduct({ purityId });
        }
    }, []);
    if (isLoading) {
        // Add Loader Here
        return null;
    }
    return (
        <GridContainer {...styles.container}>
            {successful === true && !fields.isLegacyPage ? (
                <>
                    <GridItem {...styles.leftColumnGridItem} data-test-selector="productDetails_leftColumn">
                        <GridContainer {...styles.leftColumnInnerContainer}>
                            <GridItem {...styles.topGridItem}>
                                <Zone contentId={id} zoneName="Content0" />
                            </GridItem>

                            <GridItem {...styles.bottomGridItem}>
                                <GAIASignInRequiredToBrowseWrapper redirectToSignIn={false}>
                                    <Zone contentId={id} zoneName="Content2" />
                                </GAIASignInRequiredToBrowseWrapper>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem {...styles.rightColumnGridItem} data-test-selector="productDetails_rightColumn">
                        <Zone contentId={id} zoneName="Content3" />
                    </GridItem>
                    <GridItem {...styles.fullWidthGridItem}>
                        <GridContainer>
                            <GridItem {...styles.fullWidthInnerGridItem}>
                                <Zone contentId={id} zoneName="Content4" />
                            </GridItem>
                        </GridContainer>
                        <GridContainer>
                            <GridItem {...styles.fullWidthInnerGridItem}>
                                <Zone contentId={id} zoneName="Content5" />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </>
            ) : (
                <>
                    <GridItem {...styles.fullWidthGridItem}>
                        <Zone contentId={id} zoneName="Content7" />
                    </GridItem>
                </>
            )}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(GAIAMYHProductDetailsView),
    definition: {
        displayName: "MYH View",
        fieldDefinitions: [
            
            {
                name: fields.isLegacyPage,
                displayName: "Is Legacy Page",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
        group: "MYH Product Details" as WidgetGroup,
    },
};

export default widgetModule;
